<script>
import Icons from '../../stuff/icons.json'
import { createDrawingTool } from './drawing-tool.js'
export default createDrawingTool('RangeTool', function() {
            return {
                // Descriptor for the tool
                group: 'Measurements', category: 'Measurements', icon: Icons['price_range.png'],
                name: 'Price Range',
                type: 'Price',
                hint: 'Price Range',
                data: [],     // Default data
                settings: {}, // Default settings
                mods: {
                    'Time': {
                        // Rewrites the default setting fields
                        icon: Icons['time_range.png'],
                        category: 'Measurements',
                        settings: { price: false, time: true },
                        name: 'Date Range'
                    },
                    'PriceTime': {
                        // Rewrites the default setting fields
                        icon: Icons['price_time.png'],
                        category: 'Measurements',
                        settings: { price: true, time: true },
                        name: 'Date and Price Range'
                    },
                    'ShiftMode': {
                        // Rewrites the default setting fields
                        settings: {
                            price: true, time: true,
                            shiftMode: true
                        },
                        category: 'Measurements',
                        hidden: true,
                        name: 'Date and Price Range'
                    }
                }
            }
        }, s => s.price && s.time ? 'Date and Price Range' : s.time ? 'Date Range' : 'Price Range')
</script>
